import React, { useEffect, useLayoutEffect, useRef, useState, useCallback } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Style/typo.css";
import "./assets/css/style-video.css";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import DeskIcon1 from "./assets/image/desk_icon1.png";
import DeskIcon2 from "./assets/image/desk_icon2.png";
import DeskIcon3 from "./assets/image/desk_icon3.png";
// import DeskIcon4 from "./assets/image/desk_icon4.png";
// import DeskIcon5 from "./assets/image/desk_icon5.png";
import DeskIcon6 from "./assets/image/desk_icon6.png";
import DeskIcon7 from "./assets/image/desk_icon7.png";
import VideoImg from "./assets/image/video-img.png";
import VideoFeatureImg1 from "./assets/image/video-feature-img1.png";
import VideoImage from "./assets/image/video-image.png";
import VideoImage1 from "./assets/image/video-image1.png";
import VideoImage2 from "./assets/image/video-image2.png";
import VideoImage3 from "./assets/image/video-image3.png";
// import VideoFeatureImg2 from "./assets/image/video-feature-img2.png";
// import VideoFeatureImg3 from "./assets/image/video-feature-img3.png";
// FadeInSection removed (TalkBanner removed)
import { fontFace } from "polished";



export function TalkBody({ activeTab, setActiveTab, tabData }) {
    const tabs = [
        {
            id: "hanbirotalk",
            label: "메신저",
            href: "#hanbirotalk",
            // icon: <MobileScreenIcon className="talk-tab-icon" style={{ width: "16px", height: "16px", flexShrink: 0 }} />,
        },
        {
            id: "videoconference",
            label: "화상회의",
            href: "#videoconference",
            // icon: <UsersViewfinderIcon className="talk-tab-icon" style={{ width: "16px", height: "16px", flexShrink: 0 }} />,
        },
    ];

    const handleTabClick = (event, tabId) => {
        event.preventDefault();
        setActiveTab(tabId);

        const target = document.getElementById(tabId);
        if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <>
            {/* Tab navigation — giữ trong container có max-width */}
            <section className="video-block" style={{ paddingBottom: "60px" }}>
                <div className="fit-video-box">
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <nav style={{ width: 'fit-content' }} className="talk-tabs nav nav-pills" aria-label="Talk tabs">
                            {tabs.map((tab) => (
                                <a
                                    key={tab.id}
                                    className={`nav-link talk-tab-link ${activeTab === tab.id ? "active" : ""}`}
                                    href={tab.href}
                                    onClick={(event) => handleTabClick(event, tab.id)}
                                    style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "center" }}
                                >
                                    {tab.icon}
                                    <span className="typo-21-nm">{tab.label}</span>
                                </a>
                            ))}
                        </nav>
                    </div>
                </div>
            </section>

            {/* Tab panels — full-width, không bị giới hạn bởi container */}
            <div className="talk-tab-panels">
                {tabs.map((tab) => (
                    <article
                        id={tab.id}
                        className="talk-tab-panel"
                        key={tab.id}
                        style={{ display: activeTab === tab.id ? "block" : "none" }}
                    >
                        {tabData[tab.id]?.error ? (
                            <div style={{ padding: "40px", textAlign: "center", color: "#d9534f" }}>
                                Error loading {tab.label}.
                            </div>
                        ) : tabData[tab.id]?.html ? (
                            <div dangerouslySetInnerHTML={{ __html: tabData[tab.id].html }} />
                        ) : (
                            <div style={{ padding: "40px", textAlign: "center", color: "#666" }}>
                                Loading {tab.label}...
                            </div>
                        )}
                    </article>
                ))}
            </div>
        </>
    );
}

export function TalkContent({ onTabChange, activeTab: activeTabProp } = {}) {
    const [activeTab, setActiveTab] = useState(activeTabProp || "hanbirotalk");

    // Sync khi parent thay đổi activeTabProp (vd: click sidebar sub-menu)
    useEffect(() => {
        if (activeTabProp && activeTabProp !== activeTab) {
            setActiveTab(activeTabProp);
        }
    }, [activeTabProp]);

    const handleSetActiveTab = useCallback((tabId) => {
        setActiveTab(tabId);
        if (onTabChange) onTabChange(tabId);
    }, [onTabChange]);
    const [tabData, setTabData] = useState({
        hanbirotalk: { bannerHtml: "", html: "", styles: [], scripts: [], error: false },
        videoconference: { bannerHtml: "", html: "", styles: [], scripts: [], error: false }
    });

    useEffect(() => {
        window.AOS = AOS;

        const fetchTab = (url, tabId, baseUrl, relativePrefix) => {
            fetch(url)
                .then((res) => {
                    if (!res.ok) {
                        throw new Error(`HTTP error! status: ${res.status}`);
                    }
                    return res.text();
                })
                .then((data) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(data, "text/html");

                    const fixUrl = (val) => {
                        if (val && !val.startsWith("data:") && !val.startsWith("http") && !val.startsWith("//") && !val.startsWith("#") && !val.startsWith("javascript:")) {
                            let cleanUrl = val.startsWith("./") ? val.substring(2) : val;
                            if (cleanUrl.startsWith("asset/image/")) {
                                return baseUrl.includes("127.0.0.1") || baseUrl.includes("localhost")
                                    ? `${relativePrefix}${cleanUrl}`
                                    : `${baseUrl}/assets/images/cloud/${cleanUrl.substring(12)}`;
                            }
                            return cleanUrl.startsWith("/") ? `${baseUrl}${cleanUrl}` : `${relativePrefix}${cleanUrl}`;
                        }
                        return val;
                    };

                    // Fix images
                    doc.querySelectorAll("img, source").forEach((el) => {
                        const src = el.getAttribute("src");
                        if (src) el.setAttribute("src", fixUrl(src));
                        const srcset = el.getAttribute("srcset");
                        if (srcset) el.setAttribute("srcset", fixUrl(srcset));
                    });

                    // Fix inline styles
                    doc.querySelectorAll("[style]").forEach((el) => {
                        const style = el.getAttribute("style");
                        if (style && style.includes("url(")) {
                            const newStyle = style.replace(/url\(['"]?([^'"]+)['"]?\)/g, (match, url) => {
                                return `url('${fixUrl(url)}')`;
                            });
                            el.setAttribute("style", newStyle);
                        }
                    });

                    // Extract styles
                    const styles = [];
                    doc.querySelectorAll("style").forEach((styleEl) => {
                        let css = styleEl.innerHTML;
                        css = css.replace(/url\(['"]?([^'"]+)['"]?\)/g, (match, url) => {
                            return `url('${fixUrl(url)}')`;
                        });
                        styles.push(css);
                    });

                    // Extract scripts
                    const scripts = [];
                    doc.querySelectorAll("script").forEach((scriptEl) => {
                        if (scriptEl.src && scriptEl.src.includes("aos")) return;

                        const attrs = [];
                        Array.from(scriptEl.attributes).forEach((attr) => {
                            attrs.push({ name: attr.name, value: attr.value });
                        });

                        let content = scriptEl.innerHTML;
                        content = content.replace(/AOS\.init\(.*?\);?/g, "");

                        scripts.push({
                            src: scriptEl.getAttribute("src"),
                            content: content,
                            attributes: attrs
                        });
                    });

                    // Separate banner and body content
                    const bannerEl = doc.querySelector(".ht-banner-wrap, .vc-banner-wrap");
                    let bannerHtml = "";
                    if (bannerEl) {
                        // Remove vc-fade so banner is always visible (not hidden by opacity:0)
                        bannerEl.querySelectorAll(".vc-fade").forEach(el => {
                            el.classList.remove("vc-fade");
                            el.classList.add("vc-visible");
                        });
                        bannerHtml = bannerEl.outerHTML;
                        bannerEl.remove();
                    }
                    const html = doc.body.innerHTML;

                    setTabData(prev => ({
                        ...prev,
                        [tabId]: { bannerHtml, html, styles, scripts, error: false }
                    }));
                })
                .catch((err) => {
                    console.error(`Error loading content for ${tabId}:`, err);
                    setTabData(prev => ({
                        ...prev,
                        [tabId]: { ...prev[tabId], error: true }
                    }));
                });
        };

        const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

        fetchTab(
            "/software/fetch-hanbiro-talk.html",
            "hanbirotalk",
            isLocal ? window.location.origin : "https://hanbiro.com",
            isLocal ? `${window.location.origin}/software/` : "https://hanbiro.com/software/"
        );

        fetchTab(
            "/software/fetch-video-conference.html",
            "videoconference",
            "https://hanbiro.com",
            "https://hanbiro.com/software/"
        );
    }, []);

    useEffect(() => {
        // Clean up previous scripts and styles
        document.querySelectorAll(".active-tab-style, .active-tab-script").forEach(el => el.remove());

        // Always inject videoconference CSS — banner cố định luôn dùng CSS này
        const vcStyles = tabData["videoconference"]?.styles || [];
        vcStyles.forEach((cssContent) => {
            const style = document.createElement("style");
            style.className = "active-tab-style";
            style.innerHTML = cssContent;
            document.head.appendChild(style);
        });

        // Inject scripts của tab hiện tại
        if (activeTab) {
            const data = tabData[activeTab];
            if (data) {
                data.scripts.forEach((scriptData) => {
                    const script = document.createElement("script");
                    script.className = "active-tab-script";
                    scriptData.attributes.forEach((attr) => {
                        script.setAttribute(attr.name, attr.value);
                    });

                    if (scriptData.content.trim()) {
                        const safeContent = `
                            try {
                                ${scriptData.content}
                            } catch (e) {
                                console.error("Error executing fetched inline script:", e);
                            }
                        `;
                        script.appendChild(document.createTextNode(safeContent));
                    }
                    document.body.appendChild(script);
                });
            }
        }

        // Re-initialize AOS
        setTimeout(() => {
            if (window.AOS) {
                window.AOS.init({ once: true });
                window.AOS.refresh();
            }
        }, 100);

        return () => {
            document.querySelectorAll(".active-tab-style, .active-tab-script").forEach(el => el.remove());
        };
    }, [activeTab, tabData]);

    const fixedBannerHtml = tabData["videoconference"]?.bannerHtml;

    return (
        <>
            {fixedBannerHtml && (
                <div dangerouslySetInnerHTML={{ __html: fixedBannerHtml }} />
            )}
            <TalkBody activeTab={activeTab} setActiveTab={handleSetActiveTab} tabData={tabData} />
        </>
    );
}

function HanbiroTalk() {
    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />
            <TalkContent />
            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default HanbiroTalk;

export const UsersViewfinderIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="currentColor">
        <path d="M48 48l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 0C14.3 0 0 14.3 0 32L0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-17.7-14.3-32-32-32L504 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464l0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 480c0 17.7 14.3 32 32 32l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c17.7 0 32-14.3 32-32l0-104c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0z" />
    </svg>
);

export const UsersMedicalIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="currentColor">
        <path d="M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM405.3 320l77.4 0c6.6-18.6 24.4-32 45.3-32l32 0c20.9 0 38.7 13.4 45.3 32l13.4 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM416 400c0-14.6 6.5-27.7 16.9-36.5C416.3 356.1 398 352 378.7 352l-117.3 0C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l328.1 0c-1.8-5-2.7-10.4-2.7-16l0-16-16 0c-26.5 0-48-21.5-48-48l0-32zm0-176a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm96 112l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z" />
    </svg>
);

export const MobileScreenIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor">
        <path d="M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM144 448c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM304 64L80 64l0 320 224 0 0-320z" />
    </svg>
);

export const ArrowPointerIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor">
        <path d="M0 55.2L0 426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320l118.1 0c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z" />
    </svg>
);
